export const FETCH_WORKKARD_DETAIL_MASTER_DATA = "FETCH_WORKKARD_DETAIL_MASTER_DATA";
export const WORKKARD_DETAIL_MASTER_DATA_SUCCESS = "WORKKARD_DETAIL_MASTER_DATA_SUCCESS";
export const SHOW_DETAIL_PAGE_LOADER = "SHOW_DETAIL_PAGE_LOADER";
export const HIDE_DETAIL_PAGE_LOADER = "HIDE_DETAIL_PAGE_LOADER";
export const WORKKARD_DETAIL_MASTER_DATA_ERROR = "WORKKARD_DETAIL_MASTER_DATA_ERROR";
export const RESET_WORKKARD_DETAIL_DATA = "RESET_WORKKARD_DETAIL_DATA";
export const RESET_PANEL_VISIBILITY = "RESET_PANEL_VISIBILITY";
export const UPDATE_WORKKARD_FIELD  = "UPDATE_WORKKARD_FIELD";
export const FETCH_WORKKARD_CARRIER =  "FETCH_WORKKARD_CARRIER";
export const FETCH_WORKKARD_CARRIER_SUCCESS =  "FETCH_WORKKARD_CARRIER_SUCCESS";

export const ACTIVITY_LISTING_DATA = "ACTIVITY_LISTING_DATA";
export const ACTIVITY_NOTE_TEMPLATES = "ACTIVITY_NOTE_TEMPLATES";
export const ACTIVITY_NOTE_TEMPLATES_SUCCESS = "ACTIVITY_NOTE_TEMPLATES_SUCCESS";
export const ACTIVITY_LISTING_SUCCESS = "ACTIVITY_LISTING_SUCCESS";
export const ACTIVITY_LISTING_ERROR = "ACTIVITY_LISTING_ERROR";

export const UPDATE_ACTIVITY_STATUS_SUCCESS = 'UPDATE_ACTIVITY_STATUS_SUCCESS';
export const EDIT_ACTIVITY_DATA_SUCCESS = 'EDIT_ACTIVITY_DATA_SUCCESS';

export const FETCH_ASSOCIATED_WARKKARD_DATA = "FETCH_ASSOCIATED_WARKKARD_DATA";
export const CLEAR_ASSOCIATED_WORKKARD_DATA = "CLEAR_ASSOCIATED_WORKKARD_DATA";
export const FETCH_ASSOCIATED_WARKKARD_DATA_SUCCESS = "FETCH_ASSOCIATED_WARKKARD_DATA_SUCCESS";
export const FETCH_ASSOCIATED_WARKKARD_DATA_ERROR = "FETCH_ASSOCIATED_WARKKARD_DATA_ERROR";

export const FETCH_ASSOCIATED_WARKKARD_FILTER = "FETCH_ASSOCIATED_WARKKARD_FILTER";
export const FETCH_ASSOCIATED_WARKKARD_FILTER_ERROR = "FETCH_ASSOCIATED_WARKKARD_FILTER_ERROR";
export const FETCH_ASSOCIATED_WARKKARD_FILTER_SUCCESS = "FETCH_ASSOCIATED_WARKKARD_FILTER_SUCCESS";
export const UPDATE_ASSOCIATED_WARKKARD_FILTER_SUCCESS = "UPDATE_ASSOCIATED_WARKKARD_FILTER_SUCCESS";
export const UPDATE_ASSOCIATED_WARKKARD_ORG_FILTER_SUCCESS = "UPDATE_ASSOCIATED_WARKKARD_ORG_FILTER_SUCCESS";

export const FETCH_ACTIVITY_DETAIL_DATA = "FETCH_ACTIVITY_DETAIL_DATA";
export const ACTIVITY_DETAIL_DATA_SUCCESS = "ACTIVITY_DETAIL_DATA_SUCCESS";
export const ACTIVITY_DETAIL_DATA_ERROR = "ACTIVITY_DETAIL_DATA_ERROR";
export const ACTIVITY_DETAIL_FULL_REPLACE = "ACTIVITY_DETAIL_FULL_REPLACE";

export const UPDATE_ACTIVITY_LISTING_SUCCESS ="UPDATE_ACTIVITY_LISTING_SUCCESS";
export const FETCH_ACTIVITY_TEMPLATES_LIST_SUCCESS = "FETCH_ACTIVITY_TEMPLATES_LIST_SUCCESS";

export const SHOW_LISITNG_LOADER="SHOW_LISITNG_LOADER";
export const HIDE_LISITNG_LOADER="HIDE_LISITNG_LOADER";

export const ACTIVITY_WATCHER_LIST = "ACTIVITY_WATCHER_LIST";
export const WORKKARD_WATCHER_LIST = "WORKKARD_WATCHER_LIST";
export const ASSOCIATED_WORKKARDS = "ASSOCIATED_WORKKARDS";
export const FETCH_ACTIVITY_TEMPLATES_LIST = "FETCH_ACTIVITY_TEMPLATES_LIST";


export const PANEL_VISIBILITY_DATA_REQUEST = "PANEL_VISIBILITY_DATA_REQUEST";
export const PANEL_VISIBILITY_DATA_SUCCESS = "PANEL_VISIBILITY_DATA_SUCCESS";
export const PANEL_VISIBILITY_DATA_ERROR = "PANEL_VISIBILITY_DATA_ERROR";

export const GET_ALL_DRAFT_NOTES = "GET_ALL_DRAFT_NOTES";
export const GET_ALL_NOTE_TEMPLATES = "GET_ALL_NOTE_TEMPLATES";
export const GET_SELECTED_NOTE_TEMPLATE_DATA = "GET_SELECTED_NOTE_TEMPLATE_DATA";
export const TOGGLE_CREATE_NOTE_LOADING = "TOGGLE_CREATE_NOTE_LOADING";
export const DISCARD_SELECTED_NOTE_TEMPLATE = "DISCARD_SELECTED_NOTE_TEMPLATE";
export const GET_ALL_DRAFTS_COUNT = "GET_ALL_DRAFTS_COUNT";

export const NOTE_TEMPLATES_DATA_SUCCESS = "NOTE_TEMPLATES_DATA_SUCCESS";
export const NOTE_TEMPLATES_DATA_ERROR = "NOTE_TEMPLATES_DATA_ERROR";

export const SELECTED_NOTE_TEMPLATE_DATA_SUCCESS = "SELECTED_NOTE_TEMPLATE_DATA_SUCCESS";
export const SELECTED_NOTE_TEMPLATE_DATA_ERROR = "SELECTED_NOTE_TEMPLATE_DATA_ERROR";

export const GET_WORKKARD_ACTIVITY_NOTE_FILES = "GET_WORKKARD_ACTIVITY_NOTE_FILES";
export const GET_WORKKARD_ACTIVITY_NOTE_FILES_SUCCESS = "GET_WORKKARD_ACTIVITY_NOTE_FILES_SUCCESS";
export const PUBLISH_NOTE = "PUBLISH_NOTE";
export const CLONE_SAVED_NOTE = "CLONE_SAVED_NOTE";
export const EDIT_DRAFT_NOTE_REQUEST = "EDIT_DRAFT_NOTE_REQUEST";
export const SAVE_DRAFT_NOTE = "SAVE_DRAFT_NOTE";
export const CHANGE_TEMPLATE_TYPE = "CHANGE_TEMPLATE_TYPE";
export const CHANGE_NOTE_TEMPLATE_TYPE = "CHANGE_NOTE_TEMPLATE_TYPE";
export const CLONE_SAVED_NOTE_TO_DRAFT_REQUEST = "CLONE_SAVED_NOTE_TO_DRAFT_REQUEST";
export const PUBLISH_SAVED_NOTE = "PUBLISH_SAVED_NOTE";
export const PUBLISH_SAVED_NOTE_WORKKARD = "PUBLISH_SAVED_NOTE_WORKKARD";
export const PUBLISH_SAVED_NOTE_INTERNAL_WORKKARD = "PUBLISH_SAVED_NOTE_INTERNAL_WORKKARD";
export const PUBLISH_SAVED_NOTE_INTERNAL = "PUBLISH_SAVED_NOTE_INTERNAL";
export const DELETE_SAVED_NOTE_REQUEST = "DELETE_SAVED_NOTE_REQUEST";
export const DELETE_SAVED_WORKKARD_NOTE_REQUEST = "DELETE_SAVED_WORKKARD_NOTE_REQUEST";
export const CHANGE_NOTE_TYPE = "CHANGE_NOTE_TYPE";
export const CHANGE_NOTE_TYPE_SUCCESS = "CHANGE_NOTE_TYPE_SUCCESS";
export const RESET_NOTE_CREATION_STATE = "RESET_NOTE_CREATION_STATE";
export const CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST = "CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST";
export const SET_ACTIVITY_ID = "SET_ACTIVITY_ID";
export const SAVE_AND_UPDATE_FILE_CAPTION = 'SAVE_AND_UPDATE_FILE_CAPTION';

export const FETCH_WORKKARD_FILES_REQUEST_SUCCESS = 'FETCH_WORKKARD_FILES_REQUEST_SUCCESS';
export const FETCH_WORKKARD_LETTER_REQUEST = 'FETCH_WORKKARD_LETTER_REQUEST';
export const FETCH_WORKKARD_LETTER_REQUEST_SUCCESS = 'FETCH_WORKKARD_LETTER_REQUEST_SUCCESS';
export const RESET_WORKKARD_FILES_REQUEST='RESET_WORKKARD_FILES_REQUEST';
export const RESET_WORKKARD_FILES_REQUEST_SUCCESS='RESET_WORKKARD_FILES_REQUEST_SUCCESS';
export const RESET_WORKKARD_LETTERS_REQUEST='RESET_WORKKARD_LETTERS_REQUEST';
export const RESET_WORKKARD_LETTERS_REQUEST_SUCCESS='RESET_WORKKARD_LETTERS_REQUEST_SUCCESS';

export const IS_SELECT_ALL_LETTER='IS_SELECT_ALL_LETTER';

export const TOGGLE_VIEW="TOGGLE_VIEW";

export const FETCH_OPEN_ACTIVITY_DIARIES_REQUEST = 'FETCH_OPEN_ACTIVITY_DIARIES_REQUEST';
export const FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_SUCCESS = 'FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_SUCCESS';

export const FETCH_ACTIVITY_NOTIFICATION_REQUEST = 'FETCH_ACTIVITY_NOTIFICATION_REQUEST';
export const FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS = 'FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS';

export const POST_ACTIVITY_MENU_ACTION_REQUEST = 'POST_ACTIVITY_MENU_ACTION_REQUEST';

export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';

export const CLEAR_VALIDATION_ERROR_MESSAGE = 'CLEAR_VALIDATION_ERROR_MESSAGE';
export const CLOSE_ACTIVITY_VALIDATION_ERROR_MESSAGE = 'CLOSE_ACTIVITY_VALIDATION_ERROR_MESSAGE';
export const CLOSE_ACTIVITY_ACTION_DENIED_ERROR_MESSAGE = 'CLOSE_ACTIVITY_ACTION_DENIED_ERROR_MESSAGE';
export const SET_VALIDATION_ERROR_MESSAGE = 'SET_VALIDATION_ERROR_MESSAGE';

export const CLOSE_ACTIVITY_REQUEST = 'CLOSE_ACTIVITY_REQUEST';
export const CLOSE_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS = 'CLOSE_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS';

export const BULK_COMPLETE_OPEN_DIERIES_REQUEST = 'BULK_COMPLETE_OPEN_DIERIES_REQUEST';
export const CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST = 'CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST';
export const CLOSE_ACTIVITY_RESET_STATE = 'CLOSE_ACTIVITY_RESET_STATE';

//close workkard
export const FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST = 'FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST';
export const FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST = 'FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST';
export const FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST = 'FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST';
export const FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST_SUCCESS = 'FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST_SUCCESS';
export const FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST_SUCCESS = 'FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST_SUCCESS';
export const FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST_SUCCESS = 'FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST_SUCCESS';
export const FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST = 'FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST';
export const FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST_SUCCESS = 'FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST_SUCCESS';
export const CLOSE_WORKKARD_REQUEST = 'CLOSE_WORKKARD_REQUEST';
export const CLOSE_WORKKARD_BULK_COMPLETE_OPEN_DIERIES_REQUEST = 'CLOSE_WORKKARD_BULK_COMPLETE_OPEN_DIERIES_REQUEST';
export const BULK_COMPLETE_OPEN_ACTIVITIES_REQUEST = 'BULK_COMPLETE_OPEN_ACTIVITIES_REQUEST';
export const GET_CLOSE_WORKKARD_PERMISSION = 'GET_CLOSE_WORKKARD_PERMISSION';
export const CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE = 'CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE';
export const CLOSE_WORKKARD_RESET_STATE = 'CLOSE_WORKKARD_RESET_STATE';
export const CLOSE_WORKKARD_RESET_TAB_STATE = 'CLOSE_WORKKARD_RESET_TAB_STATE';

export const IS_START_TOUR = "IS_START_TOUR";
export const HIDE_SHOW_DEFAULT_TOUR = "HIDE_SHOW_DEFAULT_TOUR";
export const SET_USER_TOUR_STATUS = "SET_USER_TOUR_STATUS";
export const GET_USER_TOUR_STATUS = "GET_USER_TOUR_STATUS";

export const RESOLUTION_BASED_CLASS_REQUEST = "RESOLUTION_BASED_CLASS_REQUEST";
export const RESOLUTION_BASED_CLASS_SUCCESS = "RESOLUTION_BASED_CLASS_SUCCESS";

export const SAVE_NOTE_ERROR = "SAVE_NOTE_ERROR";
export const BUTTON_LOADER = "BUTTON_LOADER";
export const LOG_APPLICATON_ERROR = "LOG_APPLICATON_ERROR";
export const CLEAR_APPLICATON_ERROR = "CLEAR_APPLICATON_ERROR";
export const DISCARD_NOTE_REDIRECT_URL = "DISCARD_NOTE_REDIRECT_URL";

export const FETCH_CONTACT_INSURED_DETAILS_REQUEST = "FETCH_CONTACT_INSURED_DETAILS_REQUEST";
export const FETCH_CONTACT_INSURED_DETAILS_SUCCESS = "FETCH_CONTACT_INSURED_DETAILS_SUCCESS";
export const RESET_CONTACT_INSURED_DETAILS ='RESET_CONTACT_INSURED_DETAILS';

export const SAVE_CONTACT_INSURED_DETAILS = "SAVE_CONTACT_INSURED_DETAILS";
export const CONTACT_INSURED_RESPONSE_ERROR = "CONTACT_INSURED_RESPONSE_ERROR";
export const SAVE_MESSAGE_QUEUE = "SAVE_MESSAGE_QUEUE";
export const GET_TIMEZONE_BY_ZIP = "GET_TIMEZONE_BY_ZIP";
export const GET_TIMEZONE_BY_ZIP_SUCCESS = "GET_TIMEZONE_BY_ZIP_SUCCESS";
export const CLOSE_ACTIVITY_LISTING_SUCCESS = 'CLOSE_ACTIVITY_LISTING_SUCCESS';
export const CLEAR_CLOSE_ACTIVITIES = 'CLEAR_CLOSE_ACTIVITIES';
export const GET_SAVED_NOTE_FILTER_DATA = "GET_SAVED_NOTE_FILTER_DATA";
export const UPDATE_USER_CUSTOM_FIELD_DATA='UPDATE_USER_CUSTOM_FIELD_DATA';
export const RESET_USER_CUSTOM_FIELD_DATA='RESET_USER_CUSTOM_FIELD_DATA';
export const WORKKARD_USER_LIST_SUCCESS = 'WORKKARD_USER_LIST_SUCCESS';
export const FETCH_USERS_DETAIL = 'FETCH_USERS_DETAIL';
export const UPDATE_USER_PINNED_FIELDS = 'UPDATE_USER_PINNED_FIELDS'